import $axios from '~/plugins/axios';

import { Api, CampaignSplit, GetCampaignSplitParams, PaginatorResult } from '~/api';
import { buildModule, createPaginationModule } from '../utils';
import { Dict, createDict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withSubmodules({
		pagination: createPaginationModule({
			pageQueryKey: 'campaignSplitsPage',
			pageSizeQueryKey: 'campaignSplitsPerPage',
			itemCountGetter: 'campaignSplits/list/totalCount',
		}),
	})
	.withState({
		storedCampaignSplits: {} as Dict<CampaignSplit>,
		campaignSplits: [] as CampaignSplit[],
		loading: false,
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		byId: state => (splitId: CampaignSplit['id']): CampaignSplit | null => (
			state.storedCampaignSplits[splitId] ?? null
		),
		page: state => state.campaignSplits,
		loading: state => state.loading,
		totalCount: state => state.paginator?.totalCount ?? 0,
	})
	.withMutations({
		SET_STORED_CAMPAIGN_SPLITS (state, campaignSplits: CampaignSplit[]) {
			state.storedCampaignSplits = {
				...state.storedCampaignSplits,
				...createDict(campaignSplits, (split) => split.id),
			};
		},
		SET_CAMPAIGN_SPLITS (state, splitIds: CampaignSplit['id'][]) {
			state.campaignSplits = splitIds.map(id => state.storedCampaignSplits[id]);
		},
		SET_LOADING (state, loading: boolean) {
			state.loading = loading;
		},
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	})
	.withActions({
		async get ({ commit }, params: GetCampaignSplitParams = {}) {
			commit('SET_LOADING', true);
			const { data } = await api.get('/campaign-split', { params });
			commit('SET_LOADING', false);

			const campaignSplits = data.payload;
			const campaignSplitIds = campaignSplits.map(split => split.id);

			commit('SET_STORED_CAMPAIGN_SPLITS', campaignSplits);
			commit('SET_CAMPAIGN_SPLITS', campaignSplitIds);
			commit('SET_PAGINATOR', data.paginator);
		},
	});
